import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Stack,
  Tooltip,
} from "@mui/material";
import { TooltipWrapper } from "components/permissions/permissions";
import { Gem } from "lucide-react";
import { Attribute } from "../../models";
import { DataMapping } from "./choose-data";

interface AttributeTreeProps {
  dataMappings?: DataMapping[];
  selected: Attribute[];
  onChange: (checked: boolean, id: string, parentId?: string) => void;
}

export const AttributeTree = (props: AttributeTreeProps) => {

  const isSelected = (selected: Attribute[], id: string, parentId?: string) => {
    if (parentId) {
      const parent = selected.find((s) => s.key == parentId);
      if (parent) {
        //@ts-ignore
        return parent.attributes.indexOf(id) > -1;
      }
      return false;
    } else {
      const item = selected.find((s) => s.key == id);
      return !!item;
    }
  };

  const isParentSelected = (parentId: string) => {
    return isSelected(props.selected, parentId, undefined);
  };

  return (
    <Box display="flex" flexDirection="column" ml={3}>
      {props.dataMappings?.map((dataMapping, idx: number) => (
        <Box key={`data-tree-${idx}`}>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{ mr: 1 }}
              label={dataMapping.name}
              id={`label-${dataMapping.name.replaceAll(" ", "-")}`}
              control={
                <Checkbox
                  id={`checkbox-${dataMapping.name.replaceAll(" ", "-")}`}
                  sx={{ padding: "4px" }}
                  checked={isSelected(
                    props.selected,
                    dataMapping.id,
                    undefined
                  )}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>,
                    checked: boolean
                  ) => props.onChange(checked, dataMapping.id, undefined)}
                />
              }
            />
            {dataMapping.credits && (
              <Chip
                size="small"
                label={`${dataMapping.credits} Credits`}
                variant="outlined"
              />
            )}
            {dataMapping.isPremium && (
              <TooltipWrapper
                style={{
                  width: "24px",
                  height: "24px",
                }}
                title="Premium Data"
              >
                <Gem color="#1876d3" />
              </TooltipWrapper>
            )}
          </Stack>
          <Box display="flex" flexDirection="column" ml={3}>
            {dataMapping.children?.map((child) => (
              <Stack direction="row" alignItems="center">
                <FormControlLabel
                  sx={{ mr: 1 }}
                  label={child.name}
                  id={`label-${child.name.replaceAll(" ", "-")}`}
                  disabled={!isParentSelected(dataMapping.id)}
                  control={
                    <Checkbox
                      id={`checkbox-${child.name.replaceAll(" ", "-")}`}
                      sx={{ padding: "4px" }}
                      checked={isSelected(
                        props.selected,
                        child.id,
                        dataMapping.id
                      )}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>,
                        checked: boolean
                      ) => props.onChange(checked, child.id, dataMapping.id)}
                    />
                  }
                />
                {dataMapping.credits && (
                  <Chip
                    size="small"
                    label={`${child.credits} Credits`}
                    disabled={!isParentSelected(dataMapping.id)}
                    variant="outlined"
                  />
                )}
                {child.tooltip && (
                  <Tooltip title={child.tooltip} placement="top">
                    <InfoIcon color="primary" />
                  </Tooltip>
                )}
              </Stack>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
